'use client';

import { Children, cloneElement, isValidElement, type ReactElement, useRef } from 'react';
import { DraggableContainer } from '@/app/elements/draggable-wrapper/draggable-container';
import { classes } from '@/utils/classes/classes';
import { useCarouselSnap } from './use-carousel-snap';

type InfluencerGameplaySessionsCarouselProps = {
    children: ReactElement[];
};

export const InfluencerGameplaySessionsCarousel = ({ children }: InfluencerGameplaySessionsCarouselProps) => {
    const rootRef = useRef<HTMLDivElement>(null);
    const itemCount = children.length;
    const { activeIndex, canPaginate, goToIndex } = useCarouselSnap(rootRef, itemCount);

    return (
        <div
            ref={rootRef}
            className="influencer-gameplay-sessions__carousel"
            data-testid="influencer-gameplay-sessions-carousel">
            <DraggableContainer
                indicators={canPaginate}
                observeResize
                onIndicatorClick={(direction) => goToIndex(activeIndex + direction)}>
                {Children.map(children, (child, index) =>
                    isValidElement(child)
                        ? cloneElement(child as ReactElement<{ isPlaybackCandidate?: boolean }>, {
                              isPlaybackCandidate: index === activeIndex
                          })
                        : child
                )}
            </DraggableContainer>
            {canPaginate && (
                <div className="influencer-gameplay-sessions__dots">
                    {children.map((child, index) => (
                        <button
                            key={child.key}
                            type="button"
                            className={classes(
                                'influencer-gameplay-sessions__dot',
                                index === activeIndex && 'is-active'
                            )}
                            aria-label={`Go to video ${index + 1}`}
                            aria-current={index === activeIndex}
                            onClick={() => goToIndex(index)}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};
